import Associates from "./Associates";
import CallToAction from "./CallToAction";
import LoanSteps from "./Loansteps";
import { useNavigate } from "react-router-dom";

const ServicePage = () => {
    const navigate = useNavigate();

    const loanData = [
        {
            title: "Personal Loan - Quick & Hassle-Free Approval",
            description: "Personalized loan solutions with flexible repayment options and competitive interest rates. No hidden fees and fast approvals with Money Vision .",
            icon: "fa-wallet",
            link: "/personal-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Business Loan - Fuel Your Growth",
            description: "Empower your business with tailored financing solutions. Access working capital, expansion funds, and equipment financing with expert support.",
            icon: "fa-briefcase",
            link: "/business-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Home Loan - Your Dream Home Awaits",
            description: "Secure a home loan with competitive rates and expert guidance. Whether buying a new home or refinancing, we make the process simple and stress-free.",
            icon: "fa-home",
            link: "/home-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Mortgage Loan - Smart Financing for Homeowners",
            description: "Flexible mortgage solutions designed for homeowners. Benefit from low-interest rates, easy approvals, and expert assistance tailored to your needs.",
            icon: "fa-hand-holding-dollar",
            link: "/mortgage-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Working Capital Loan - Maintain Cash Flow",
            description: "Short-term financing to manage operational expenses, inventory, and payroll. Flexible terms to keep your business running smoothly.",
            icon: "fa-money-bill-wave",
            link: "/working-capital-loan-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Loan Against Shares - Leverage Your Investments",
            description: "Get funds against your demat shares and mutual funds without selling them. Quick approval and competitive rates.",
            icon: "fa-chart-line",
            link: "/loan-against-shares-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Life Insurance - Secure Your Future",
            description: "Life insurance plans to protect your loved ones and secure your financial future. Choose from term life, whole life, and endowment policies with competitive premiums.",
            icon: "fa-user-shield",
            link: "/life-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "General Insurance - Protect What Matters",
            description: "Comprehensive general insurance solutions covering health, vehicle, property, and more. Protect what matters with affordable premiums and reliable coverage.",
            icon: "fa-shield-alt",
            link: "/general-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Health Insurance - Secure Your Well-being",
            description: "Affordable health insurance plans for individuals and families. Coverage for medical expenses, hospitalization, and preventive care with top providers.",
            icon: "fa-heartbeat",
            link: "/health-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Vehicle Insurance - Protect Your Ride",
            description: "Reliable vehicle insurance for cars, bikes, and more. Comprehensive coverage including third-party liability, own damage, and add-on benefits.",
            icon: "fa-car",
            link: "/vehicle-insurance-mumbai-thane-palghar-maharashtra-delhi-india",
        },
        {
            title: "Mutual Funds - Grow Your Wealth",
            description: "Invest in mutual funds for diversified portfolios and long-term growth. Expert advice on equity, debt, and hybrid funds to meet your financial goals.",
            icon: "fa-chart-pie",
            link: "/mutual-funds-mumbai-thane-palghar-maharashtra-delhi-india",
        }


    ];

    return (
        <>
            <div className="other-pages-main-section service-page-fin">
                <h2 className="other-pages-title">Our Services</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/loan-services-india")} style={{ cursor: "pointer" }}>Services</span>
                </p>
            </div>

            <Associates />

            <div className="loan-card-main">
                <h2 className="sections-title-smco">
                    <span className="horizontal-line"></span>Our Core Services
                </h2>
                <p className="sections-description-smco">
                    Quick approvals, low rates, and hassle-free loans tailored for you.
                </p>

                <div className="loan-cards-container-smco">
                    {loanData.map((loan, index) => (
                        <div
                            key={index}
                            className="loan-card-smco"
                            onClick={() => navigate(loan.link)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="loan-card-container-icon-dashed-border">
                                <div className="loan-card-icon-container-smco">
                                    <i className={`fa-solid ${loan.icon} loan-card-icon-smco`}></i>
                                </div>
                            </div>
                            <h3 className="loan-card-title-smco">{loan.title}</h3>
                            <p className="loan-card-description-smco">{loan.description}</p>

                            {/* Learn More Button */}
                            <button
                                className="loan-card-button-smco"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(loan.link);
                                }}
                            >
                                Learn More
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default ServicePage;
